import parseAndValidateUpload from 'app/components/analytics-builder/export-import/upload/parseAndValidateUpload';
import parseSettingsTemplate from 'app/components/analytics-builder/parseSettingsTemplate';
import populateFormFromUpload from './populateFormFromUpload';

/**
 * Upload and hydrate Analytics File form from YAML content
 *
 * @param {object} params - Upload parameters
 * @param {string} params.fileContent - Raw YAML file content
 * @param {function} params.setField - Form setField function
 * @param {function} params.addIdentitySyncs - Function to add identity syncs to staged list
 * @param {function} params.addIntegrations - Function to add integrations to staged list
 * @param {string} params.updateMode - Update mode (override or merge)
 * @param {array} params.stagedIdentitySyncs - Current staged identity syncs (for merge mode)
 * @param {array} params.stagedIntegrations - Current staged integrations (for merge mode)
 * @returns {object} { success: boolean, errors: string[] }
 */
export default function uploadAnalyticsFile({
  fileContent,
  setField,
  addIdentitySyncs,
  addIntegrations,
  updateMode,
  stagedIdentitySyncs,
  stagedIntegrations,
}) {
  const parseResult = parseAndValidateUpload({ fileContent, updateMode });

  if (!parseResult.success) {
    return { success: false, errors: parseResult.errors };
  }

  const analyticsFileData = parseSettingsTemplate(parseResult.data);

  populateFormFromUpload({
    analyticsFileData,
    setField,
    addIdentitySyncs,
    addIntegrations,
    updateMode,
    stagedIdentitySyncs,
    stagedIntegrations,
  });

  return { success: true, errors: [] };
}

export { parseSettingsTemplate };
